import React from 'react'
import { useState } from 'react';
import { useAlert } from "react-alert";
import CPersonalInfo from './CPersonalInfo';
import { TransitEnterexitRounded } from '@material-ui/icons';
import TaxDetail from './TaxDetail';
import ClientComplete from './ClientComplete';



function Form2() {
    const alert = useAlert();


    const [firstname, setfirstname] = useState();
    const [lastname, setlastname] = useState();
    const [address, setaddress] = useState();
    const [postcode, setpostcode] = useState();
    const [dateofbirth, setdateofbirth] = useState();
    const [ninumber, setninumber] = useState();
    const [utrnumber, setutrnumber] = useState();
    const [taxyear, settaxyear] = useState();
    const [natureofbusiness, setnatureofbusiness] = useState();
    const [turnover, setturnover] = useState();
    const [tips, settips] = useState();
    const [otherbusinessincome, setotherbusinessincome] = useState();
    const [fuel, setfuel] = useState();
    const [insurance, setinsurance] = useState();
    const [radiorent, setradiorent] = useState();
    const [licensingfee, setlicensingfee] = useState();
    const [mobilecommunication, setmobilecommunication] = useState();
    const [repair, setrepair] = useState();
    const [accountingcost, setaccountingcost] = useState();
    const [bankcharges, setbankcharges] = useState();
    const [otherexpense, setotherexpense] = useState();
    const [car, setcar] = useState();
    const [carmileage, setcarmileage] = useState();
    const [capitalpersonaluse, setcapitalpersonaluse] = useState();
    const [personaluse, setpersonaluse] = useState();
    const [otherincomeincludeproperty, setotherincomeincludeproperty] = useState();
    const [valueofcar, setvalueofcar] = useState();
    const [caremission, setcaremission] = useState();
    const [loading, setloading] = useState(false);
    const [step, setstep] = useState(1);


    const formSubmitHondler = async (e) => {
        setloading(true)
        e.preventDefault();

        const res = await fetch('https://ajh-accountant.onrender.com/api/client-forms', {

            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: {
                    firstname, lastname, address, postcode, dateofbirth, ninumber, utrnumber, taxyear, natureofbusiness,
                    turnover, tips, otherbusinessincome, fuel, insurance, radiorent, licensingfee, mobilecommunication, repair, accountingcost,
                    bankcharges, otherexpense, car, carmileage, capitalpersonaluse, personaluse, otherincomeincludeproperty, valueofcar
                    , caremission
                }
            })
        }).then((response) => {
            response.json()
            setloading(false)
            alert.success("Form Submitted Successfully");

        }).catch((error) => {
            setloading(true)
            alert.success(error);
        })

        setstep(step + 1)

        // const data = await res.json()


        setfirstname('');
        setlastname('');
        setaddress('');
        setpostcode('');
        setdateofbirth('');
        setninumber('');
        setutrnumber('');
        settaxyear('');
        setnatureofbusiness('');
        setturnover('');
        settips('');
        setotherbusinessincome('');
        setfuel('');
        setinsurance('');
        setradiorent('');
        setlicensingfee('');
        setmobilecommunication('');
        setrepair('');
        setaccountingcost('');
        setbankcharges('');
        setotherexpense('');
        // setcar('');
        setcarmileage('');
        // setcapitalpersonaluse('');
        setpersonaluse('');
        setotherincomeincludeproperty('');
        setvalueofcar('');
        setcaremission('');

    }

    const [employment, setemploymet] = useState();


    return (
        <div>
            <div className="container-fluid contacts-div1">
                <svg
                    className="contact-vector1 d-sm-block d-none"
                    width="65"
                    height="201"
                    viewBox="0 0 65 201"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M103.476 0.0623773C144.217 1.51047 171.061 37.8544 183.39 76.877C195.394 114.872 192.755 158.559 161.184 182.719C127.602 208.417 81.0343 206.104 46.6254 181.535C11.0388 156.125 -9.07933 112.331 4.02486 70.5016C17.4843 27.5381 58.656 -1.53073 103.476 0.0623773Z"
                        fill="#FFB532"
                    />
                </svg>

                <div className="container service-main-contact-div2 bg-white">
                    <h1 className=" contactus-text1 text-center ">
                        Get In Touch With <span>US</span>.
                    </h1>
                    <div className="contactus-btn-div">
                        <a href="tel:+44 01204 840303">
                            <div className="contact-btn1">
                                <p className="contactus-text2 text-center">+44 01204 840303</p>
                            </div>
                        </a>
                        <a href="mailto:info@ajhaccountant.co.uk">
                            <div className="contact-btn2">
                                <p className="contactus-text2">info@ajhaccountant.co.uk</p>
                            </div>
                        </a>
                    </div>

                    <div>



            


                        {step === 1 ?
                            <CPersonalInfo
                                setfirstname={setfirstname}
                                firstname={firstname}
                                lastname={lastname}
                                setlastname={setlastname}
                                setaddress={setaddress}
                                address={address}
                                postcode={postcode}
                                setpostcode={setpostcode}
                                setdateofbirth={setdateofbirth}
                                dateofbirth={dateofbirth}
                                ninumber={ninumber}
                                setninumber={setninumber}
                                utrnumber={utrnumber}
                                setutrnumber={setutrnumber}
                                setstep={setstep}
                                step={step}>

                            </CPersonalInfo> : step === 2 ? <TaxDetail 
                            taxyear={taxyear}
                            natureofbusiness={natureofbusiness}
                            turnover={turnover}
                            tips={tips}
                            otherbusinessincome={otherbusinessincome}
                            fuel={fuel}
                            insurance={insurance}
                            radiorent={radiorent}
                            licensingfee={licensingfee}
                            mobilecommunication={mobilecommunication}
                            repair={repair}
                            accountingcost={accountingcost}
                            bankcharges={bankcharges}
                            otherexpense={otherexpense}
                            car={car}
                            carmileage={carmileage}
                            capitalpersonaluse={capitalpersonaluse}
                            personaluse={personaluse}
                            otherincomeincludeproperty={otherincomeincludeproperty}
                            valueofcar={valueofcar}
                            caremission={caremission}
                        settaxyear={settaxyear}
                        setnatureofbusiness={setnatureofbusiness}
                        setturnover={setturnover}
                        settips={settips}
                        setotherbusinessincome={setotherbusinessincome}
                        setfuel={setfuel}
                        setinsurance={setinsurance}
                        setradiorent={setradiorent}
                        setlicensingfee={setlicensingfee}
                        setmobilecommunication={setmobilecommunication}
                        setrepair={setrepair}
                        setaccountingcost={setaccountingcost}
                        setbankcharges={setbankcharges}
                        setotherexpense={setotherexpense}
                        setcar={setcar}
                        setcarmileage={setcarmileage}
                        setcapitalpersonaluse={setcapitalpersonaluse}
                        setpersonaluse={setpersonaluse}
                        setotherincomeincludeproperty={setotherincomeincludeproperty}
                        setvalueofcar={setvalueofcar}
                       setcaremission={setcaremission}
                       
                                formSubmitHondler={formSubmitHondler}
                                loading={loading}
                                step={step}
                                setstep={setstep}
                                ></TaxDetail>
                        : <ClientComplete></ClientComplete>
                            }

                      
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Form2
